// Role codes
export const ROLE_CODES = {
  SYS_ADMIN: 'SYS_ADMIN'
};

// Permission codes
export const PERMISSION_CODES = {
  // Role Management
  PERMISSION_LIST: 'PERMISSION_LIST',
  ROLE_LIST: 'ROLE_LIST',
  ROLE_DETAIL: 'ROLE_DETAIL',
  ROLE_UPDATE: 'ROLE_UPDATE',
  ROLE_CREATE: 'ROLE_CREATE',
  ROLE_DELETE: 'ROLE_DELETE',
  ROLE_USER_ROLE_LIST: 'ROLE_USER_ROLE_LIST',
  ROLE_USER_ROLE_EDIT: 'ROLE_USER_ROLE_EDIT',
  GROUP_LIST: 'GROUP_LIST',
  GROUP_DETAIL: 'GROUP_DETAIL',
  GROUP_UPDATE: 'GROUP_UPDATE',
  GROUP_CREATE: 'GROUP_CREATE',
  GROUP_DELETE: 'GROUP_DELETE',
  ROLE_GROUP_ROLE_EDIT: 'ROLE_GROUP_ROLE_EDIT',

  // Category Management
  CATEGORY_LIST: 'CATEGORY_LIST',
  CATEGORY_SUPPLIER_LIST: 'CATEGORY_SUPPLIER_LIST',
  CATEGORY_SUPPLIER_DETAIL: 'CATEGORY_SUPPLIER_DETAIL',
  CATEGORY_SUPPLIER_ADD: 'CATEGORY_SUPPLIER_ADD',
  CATEGORY_SUPPLIER_DELETE: 'CATEGORY_SUPPLIER_DELETE',
  CATEGORY_UPDATE_CAPTAIN: 'CATEGORY_UPDATE_CAPTAIN'
};
